import React from 'react';
import PropTypes from 'prop-types';

import { SMALL_TEXT_MAX_CHARACTERS, MEDIUM_TEXT_MAX_CHARACTERS } from 'constants/logic';
import Button from 'components/Button';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { Form, Input, Textarea, ButtonGroup } from 'components/HookForm';
import appMessages from 'features/App/App.messages';

import messages from './AddClasstivityClassModal.messages';

const AddClasstivityClassModal = ({ handleOnSubmit, handleOnCancel }) => (
  <Confirm size="extended" title={<Message message={messages.title} />} isOpen>
    {({ title, bodyClass }) => (
      <Form onSubmit={handleOnSubmit}>
        <>
          {title}
          <div className={bodyClass}>
            <Input
              name="className"
              required
              label={messages.className}
              minLength={3}
              maxLength={SMALL_TEXT_MAX_CHARACTERS}
            />
            <Textarea
              name="description"
              required
              label={messages.classDescription}
              minLength={3}
              maxLength={MEDIUM_TEXT_MAX_CHARACTERS}
            />
          </div>

          <ButtonGroup>
            <Message
              as={Button}
              styled="tertiary"
              message={appMessages.cancel}
              type={Button.TYPES.BUTTON}
              onClick={handleOnCancel}
            />
            <Message as={Button} styled="primary" message={appMessages.save} type={Button.TYPES.SUBMIT} />
          </ButtonGroup>
        </>
      </Form>
    )}
  </Confirm>
);

AddClasstivityClassModal.propTypes = {
  handleOnCancel: PropTypes.func,
  handleOnSubmit: PropTypes.func,
};

export default AddClasstivityClassModal;
